export default {
  menu: {},
  title: '',
  image: null,
  hasValidLicense: false,
};
